<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix" style="background-color:white; border-radius: 10px; border-width: 1px; border-style: solid; border-color: black; padding: 20px;">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops! You're lost.</h4>
          <p class="text-muted">Strona o podanym adresie nie istnieje.</p>
        </div>
      </div>
    </div>
  </div>
</div>
